export default __webpack_public_path__ + "static/media/RTR1802V_Frente.3ccbacd4.webp";